module.exports = __webpack_public_path__ + "static/rf-screenshot-activity-5a387ac12504b62880390a876f7bc078.jpg";